

import * as React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { phoneRegExp } from '../../utils/regExpresions';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import FormHelperText from '@mui/material/FormHelperText';
import Typography from '@mui/material/Typography';

const theme = createTheme();
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const getCookie = (name) => {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
export default function AccountProfileDetails(props) {
  const [actualizado, setActualizado] = React.useState(false);
  const [passValues, setValues] = React.useState({
    password: '',
    passwordConfirmation: '',
    showPassword: false,
    showPasswordConfirmation: false,
  });

  const handleCloseActualizado = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setActualizado(false);
  };
  const handleClickShowPassword = () => {
    setValues({
      ...passValues,
      showPassword: !passValues.showPassword,
    });
  };
  const handleClickShowPasswordConfirmation = () => {
    setValues({
      ...passValues,
      showPasswordConfirmation: !passValues.showPasswordConfirmation,
    });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  return (
    <React.Fragment>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <Container component="main" maxWidth="lg">
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}>
            <div style={{ width: "85%", marginBottom: "30px" }}>
              <Typography
                color="textPrimary"
                variant="h5"
                style={{ marginBottom: "0px" }}
              >
                Perfil
              </Typography>
              <Typography
                color="textPrimary"
                variant="subtitle1"
              >
                Esta informacion puede ser editada
              </Typography>
            </div>
            <Formik
              initialValues={{
                razonSocial: props.user.razon_social ? props.user.razon_social : '',
                direccion: props.user.direccion_particular ? props.user.direccion_particular : '',
                numero: props.user.telefono ? props.user.telefono : '',
                email: props.user.email ? props.user.email : '',
              }}

              validationSchema={
                Yup.object().shape({
                  razonSocial: Yup.string()
                    .max(255),

                  direccion: Yup.string()
                    .max(255),

                  numero: Yup.string()
                    .matches(phoneRegExp, 'Tiene que ser un numero de telefono valido'),

                  email: Yup.string()
                    .email('Tiene que ser un email valido')
                    .max(255)
                })
              }
              onSubmit={async (data, { setFieldError }) => {
                let token = getCookie('asa_hd_auth');
                await fetch(process.env.REACT_APP_API_ROOT + process.env.REACT_APP_API_UPDDATE_USER, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                  body: JSON.stringify({
                    email: data.email,
                    razon_social: data.razonSocial,
                    telefono: data.numero,
                    direccion_particular: data.direccion,
                    nombre_y_apellido: data.razonSocial,
                    direccion_comercial: data.direccion,
                  })
                }).then(async (result) => {
                  if (result.ok) {
                    const _result = await result.json();
                    setActualizado(true)

                  }
                }).catch((error) => {
                })
              }}
            >
              {({
                errors,
                handleSubmit,
                touched,
                values
              }) => (
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={3}>
                    <Grid item md={6} xs={12}>
                      <TextField
                        error={Boolean(touched.razonSocial && errors.razonSocial)}
                        variant="outlined"
                        name="razonSocial"
                        fullWidth
                        id="razonSocial"
                        label="Razón Social / Nombre y Apellido"
                        defaultValue={props.user.razon_social ? props.user.razon_social : props.user.nombre_y_apellido ? props.user.nombre_y_apellido : ""}
                        onChange={(event) => values.razonSocial = event.target.value}
                      />
                      {touched.razonSocial && errors.razonSocial && (
                        <FormHelperText error>
                          {errors.razonSocial}
                        </FormHelperText>
                      )}
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <TextField
                        error={Boolean(touched.direccion && errors.direccion)}
                        onChange={(event) => values.direccion = event.target.value}
                        variant="outlined"
                        fullWidth
                        id="direccion"
                        defaultValue={props.user.direccion_particular}
                        label="Dirección"
                        name="direccion"
                      />
                      {touched.direccion && errors.direccion && (
                        <FormHelperText error>
                          {errors.direccion}
                        </FormHelperText>
                      )}
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <TextField
                        error={Boolean(touched.numero && errors.numero)}
                        onChange={(event) => values.numero = event.target.value}
                        variant="outlined"
                        fullWidth
                        id="numero"
                        defaultValue={props.user.telefono}
                        label="Numero de telefono"
                        name="numero"
                      />
                      {touched.numero && errors.numero && (
                        <FormHelperText error>
                          {errors.numero}
                        </FormHelperText>
                      )}
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <TextField
                        error={Boolean(touched.email && errors.email)}
                        onChange={(event) => values.email = event.target.value}
                        variant="outlined"
                        fullWidth
                        id="email"
                        name="email"
                        defaultValue={props.user.email}
                        label="Correo electronico"
                      />
                      {touched.email && errors.email && (
                        <FormHelperText error>
                          {errors.email}
                        </FormHelperText>
                      )}
                    </Grid>
                    <Grid item xs={12}>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      sx={{ mt: 3, mb: 2 }}
                      style={{ color: "#fff", backgroundColor: "#007ccf", marginBottom: "20px", marginTop: "20px" }}
                    >
                      Actualizar Datos
                    </Button>
                  </Grid>
                </form>
              )}
            </Formik>
            <Snackbar open={actualizado} autoHideDuration={6000} onClose={handleCloseActualizado}>
              <Alert onClose={handleCloseActualizado} severity="success" sx={{ width: '100%' }}>
                Datos Actualizados
              </Alert>
            </Snackbar>
          </Box>
        </Container>
      </ThemeProvider>
    </React.Fragment >
  );
}